import { AllTranscriptsProps } from '@/types';

const HIDDEN_METADATA_KEYS = new Set(['computed_quality']);

const getUniqueMetadataKeys = (allConversations: AllTranscriptsProps[]): Set<string> => {
  const metadataKeys = new Set<string>();

  allConversations.forEach((item) => {
    if (item.metadata) {
      Object.keys(item.metadata).forEach((key) => {
        if (!HIDDEN_METADATA_KEYS.has(key)) {
          metadataKeys.add(key);
        }
      });
    }
  });

  return metadataKeys;
};

export default getUniqueMetadataKeys;
